import type { IUserProfile } from 'containers/user-profile/types'

import { useContext } from 'react'

import { UserProfileContext } from 'containers'

export const useUserProfile = (): IUserProfile => {
  const userProfile = useContext(UserProfileContext)
  return userProfile
}
